module.exports = __webpack_public_path__ + "img/screenshot-profile-completion.01eff9e3.png";